import { Box, Grid, InputAdornment, Typography } from "@material-ui/core";
import { Formik, Form } from "formik";
import { NEW, EXISTING, EXISTINGP, YES, NEWP } from "../../../../store/types";
import { convertToInr } from "../../../../utils/cart";

import CustomButton from "../../../forms/CustomButton";
import FormCheckbox from "../../../forms/formik/FormCheckbox";
import FormRadioButton, {
  FormRadio,
} from "../../../forms/formik/FormRadioField";
import FormAutoComplete, {
  FormSelect,
} from "../../../forms/formik/FormSelectField";
import SubmitButton from "../../../forms/formik/FormSubmitButton";
import FormTextInput from "../../../forms/formik/FormTextInput";
import { PURCHASE_TYPE_OPTIONS } from "../../cart/CommercialTransactions/AdditionalPurchase/useAdditionalPurchase";
import useSip from "./useSip";
import GridContainer from "../../../../lib/GridContainer";
import { AddToCartStatusModal } from "../../customModal";
import { Fragment } from "react";
import { sipOptions } from "../newInvestor";

const Sip = () => {
  const {
    changeHandlers,
    options,
    onSubmit,
    initialValues,
    validationSchema,
    modalDetails,
    pan,
    history,
    addToCart,
  } = useSip();

  return (
    <Fragment>
      <AddToCartStatusModal
        message={`Transaction has been added to cart successfully with the reference number ${modalDetails.ihNo} and bulk-order ID ${modalDetails.bulkOrderId}`}
        open={modalDetails.isOpen}
        image={"/images/cart_success.svg"}
        btn_one={"Go to cart"}
        btn_two={"Add more"}
        history={history}
        pan={pan}
        onAddTransaction={() => {
          history.push(`/cart/add-transaction/sip-existing`, {
            pan,
          });
        }}
      />

      <Formik
        initialValues={initialValues}
        onSubmit={addToCart}
        validationSchema={validationSchema}
        enableReinitialize
        validateOnBlur
      >
        {({ values, setValues, ...helpers }) => {
          const selectedScheme = options.schemes.find(
            (scheme) => scheme.value === values.scheme
          );

          const isSameScheme = values.isSameScheme;

          const isFreedom =
            values.isFreedomEligible && values.isFreedom === "freedomSip";
            const isPGIM = values.fund === "129"
            const isEnableSipAutoRenewal = isPGIM && (values.frequency==="Monthly" || values.frequency==="Quarterly") && !values.perpetual

          return (
            <Form>
              <Typography
                component={"h4"}
                style={{
                  fontWeight: "800",
                  fontSize: "24px",
                  marginBottom: "20px",
                  fontFamily: "OpenSans-SemiBold",
                }}
              >
                SIP
              </Typography>

              <FormAutoComplete
                name="fund"
                label="AMC"
                placeholder="Select AMC"
                options={options.amcMasters}
                onChange={changeHandlers.handleAmcChange(values, setValues)}
              />

              <FormAutoComplete
                name="sipType"
                options={options.sipType}
                label="SIP Type"
                placeholder="Select SIP Type"
              />
              <FormSelect
                name="folio"
                options={options.folios}
                label="Folio"
                placeholder="Select Folio"
                onChange={changeHandlers.handleFolioChange(values, setValues)}
              />

              <FormRadioButton
                label="Scheme Type"
                name="purchaseType"
                options={PURCHASE_TYPE_OPTIONS}
                onChange={changeHandlers.handlePurchaseType(values, setValues)}
              />

              {values.purchaseType === NEW ? (
                <FormAutoComplete
                  name="category"
                  label="Category"
                  placeholder="Select Category"
                  options={options.categories}
                  onChange={changeHandlers.handleCategoryChange(
                    values,
                    setValues
                  )}
                />
              ) : null}

              <FormAutoComplete
                name="scheme"
                label="Scheme"
                placeholder="Select Scheme"
                options={options.schemes}
                onChange={changeHandlers.handleSchemeChange(values, setValues)}
              />

              <FormTextInput name="arnCode" label="ARN Code" disabled />
              <FormTextInput
                name="subArn"
                label="Sub ARN Code"
                onBlur={changeHandlers.handleSubArnChange(values, setValues)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">ARN -</InputAdornment>
                  ),
                }}
              />
              <FormTextInput name="subBrokerCode" label="Sub-Broker Code" />
              <FormRadio
                name="euinDeclaration"
                label="EUIN"
                options={[
                  {
                    label: "Yes",
                    value: "Yes",
                  },
                  {
                    label: "No",
                    value: "No",
                  },
                ]}
              />
              {values.euinDeclaration === "Yes" ? (
                <FormAutoComplete
                  name="euin"
                  label="EUIN Code"
                  options={options.euinOptions}
                />
              ) : (
                <Typography
                  style={{
                    color: "rgba(128, 128, 128, 0.7)",
                  }}
                >
                  I/We hereby confirm that the EUIN box has been intentionally
                  left the blank by me/us as this is an 'execution-only'
                  transaction without any interaction or advice by any personnel
                  of the above distributor or notwithstanding the advice of
                  in-appropriateness,if any provided by any personnel of the
                  distributor and the distributor has not charged any advisory
                  fees on this transaction
                </Typography>
              )}
              <FormSelect
                name="modeOfRegistration"
                options={options.modeOptions}
                label="Select Mode Of Registration"
                onChange={changeHandlers.handleModeofRegistration(values, setValues)}
              />
              {(() => {
                return (
                  selectedScheme &&
                  selectedScheme.combo_flag === YES &&
                  [EXISTINGP].includes(values.sipType) && (
                    <FormCheckbox
                      label={selectedScheme.combo_disclaimer}
                      name="combo"
                    />
                  )
                );
              })()}

              <FormAutoComplete
                name="frequency"
                label="Select Frequency"
                options={options.frequencies}
                onChange={changeHandlers.handleFrequencyChange(
                  values,
                  setValues
                )}
              />

              {values.isFreedomEligible ? (
                <FormRadio
                  label="Type of SIP"
                  options={sipOptions}
                  name="isFreedom"
                />
              ) : null}

              {isFreedom ? (
                <Fragment>
                  <FormSelect
                    name="sipTenure"
                    label="SIP Tenure"
                    options={options.sipTenures}
                    onChange={changeHandlers.handleTenureChange(
                      values,
                      setValues
                    )}
                  />
                  <Typography variant="h6">SWP Details</Typography>
                  <FormSelect
                    name="freedomCategory"
                    options={options.freedomCategories}
                    label="Category"
                    onChange={changeHandlers.handleFreedomCategoryChange(
                      values,
                      setValues
                    )}
                  />

                  <FormCheckbox
                    name="isSameScheme"
                    label="Do you want to the target scheme to be same as SIP Scheme?"
                    onChange={changeHandlers.handleIsSameSchemeChange(
                      values,
                      setValues
                    )}
                  />

                  {isSameScheme ? (
                    <FormTextInput
                      name="swpScheme"
                      disabled
                      label="Scheme"
                      value={selectedScheme.label}
                    />
                  ) : (
                    <FormAutoComplete
                      name="swpScheme"
                      options={options.freedomSchemes}
                      label="Scheme"
                      onChange={changeHandlers.handleFreedomSchemeChange(
                        values,
                        setValues
                      )}
                    />
                  )}

                  <FormSelect
                    name="sipDay"
                    label="Sip Day"
                    options={options.sipDays}
                    onChange={changeHandlers.handleSipDayChange(
                      values,
                      setValues
                    )}
                  />

                  <GridContainer>
                    <FormTextInput
                      disabled
                      name="startDate"
                      label="SIP Start Date"
                    />
                    <FormTextInput
                      disabled
                      name="endDate"
                      label="SIP End Date"
                    />
                  </GridContainer>
                  <GridContainer>
                    <FormTextInput
                      disabled
                      name="swpStartDate"
                      label="SWP Start Date"
                    />
                    <FormTextInput
                      disabled
                      name="swpEndDate"
                      label="SWP End Date"
                    />
                  </GridContainer>
                </Fragment>
              ) : (
                <Fragment>
                  <FormTextInput
                    name="noOfInstallments"
                    label={
                      values.minimumInstallments
                        ? `No of Installments (Minimum ${values.minimumInstallments})`
                        : "No of Installments"
                    }
                    type="number"
                    onChange={changeHandlers.handleInstallmentChange(
                      values,
                      setValues
                    )}
                    disabled={!values.frequency || values.perpetual}
                  />
                  <FormSelect
                    name="sipDay"
                    label="Sip Day"
                    options={options.sipDays}
                    onChange={changeHandlers.handleSipDayChange(
                      values,
                      setValues
                    )}
                    disabled={!values.noOfInstallments || values.perpetual}
                  />

                  <FormTextInput
                    disabled
                    name="startDate"
                    label="SIP Start Date"
                  />
                  <FormTextInput disabled name="endDate" label="SIP End Date" />
                  {values.frequency && values.startDate ? (
                    <FormCheckbox
                      name="perpetual"
                      onChange={changeHandlers.handlePerpetual(
                        values,
                        setValues
                      )}
                      label="Perpetual SIP"
                    />
                  ) : null}
                   {values.frequency && values.startDate && isEnableSipAutoRenewal ? ( 
                            <FormCheckbox
                              onChange={(e) =>
                                setValues({
                                  ...values,
                                  sipAutoRenewal: e.target.checked,
                                })
                              }
                              name="sipAutoRenewal"
                              label="SIP Auto Renewal"
                            />
                         ) : null}
                </Fragment>
              )}

              <FormTextInput
                name="installmentAmount"
                label={
                  values.sipMinAmount
                    ? `SIP Amount (Minimum${convertToInr(values.sipMinAmount)})`
                    : "SIP Amount"
                }
                placeholder="Enter Installment Amount"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">{"\u20B9"}</InputAdornment>
                  ),
                }}
                type="number"
                onChange={changeHandlers.handleSipAmountChange(
                  values,
                  setValues
                )}
              />

              {[EXISTINGP].includes(values.sipType) ? (
                <FormTextInput
                  name="amount"
                  label={
                    values.newPurchaseMinAmount
                      ? `Lumpsum Amount (Minimum ${convertToInr(
                          values.newPurchaseMinAmount
                        )})`
                      : "Lumpsum Amount"
                  }
                  placeholder="Enter Lumpsum Amount"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        {"\u20B9"}
                      </InputAdornment>
                    ),
                  }}
                  type="number"
                />
              ) : null}

              {isFreedom ? (
                <FormTextInput
                  name="swpAmount"
                  label={
                    values.swpMinAmount
                      ? `SWP Amount (Minimum${convertToInr(
                          values.swpMinAmount
                        )})`
                      : "SWP Amount"
                  }
                  placeholder="Enter Withdrawal Amount"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        {"\u20B9"}
                      </InputAdornment>
                    ),
                  }}
                  type="number"
                />
              ) : null}

              <Box
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <CustomButton
                  label="Submit"
                  variant="outlined"
                  onClick={async () =>
                    await onSubmit(values, { ...helpers, setValues })
                  }
                />
                {!isFreedom && (
                  <SubmitButton label={"Add to Cart"} variant="contained" />
                )}
              </Box>
            </Form>
          );
        }}
      </Formik>
    </Fragment>
  );
};

export default Sip;
